// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Health check dashboard (admin) ======
// Pannello collassabile in fondo alla Dashboard con metriche di salute del portale.

async function renderHealth() {
  if (!isAdmin()) return;
  const root = document.getElementById('healthRoot');
  if (!root) return;
  root.innerHTML = '<p class="muted">Caricamento health…</p>';

  try {
    const { data, error } = await sb.from('health_metrics').select('*').single();
    if (error) throw error;

    const lastAuto = data.backup_auto_last ? new Date(data.backup_auto_last) : null;
    const hoursSinceAuto = lastAuto
      ? Math.floor((Date.now() - lastAuto.getTime()) / 3600000)
      : null;
    const autoState =
      hoursSinceAuto === null
        ? 'danger'
        : hoursSinceAuto < 36
          ? 'ok'
          : hoursSinceAuto < 72
            ? 'warn'
            : 'danger';

    const dormResp = await sb.rpc('dormant_users', { p_days: 60 });
    const dormant = (dormResp.data || []).filter(
      (u) => !u.last_seen || Date.now() - new Date(u.last_seen).getTime() > 60 * 86400000
    );

    root.innerHTML = `
      <div class="health-grid">
        <div class="health-card">
          <div class="h-label">Clienti</div>
          <div class="h-value">${data.clienti_tot}</div>
          <div class="h-sub">${data.clienti_senza_cpl} senza CPL</div>
        </div>
        <div class="health-card">
          <div class="h-label">Risorse team</div>
          <div class="h-value">${data.risorse_tot}</div>
        </div>
        <div class="health-card">
          <div class="h-label">Utenti portale</div>
          <div class="h-value">${data.utenti_attivi}</div>
          <div class="h-sub">${data.utenti_mai_loggati} mai loggati · ${data.utenti_disattivati} disattivati</div>
        </div>
        <div class="health-card ${autoState}">
          <div class="h-label">Ultimo backup auto</div>
          <div class="h-value">${hoursSinceAuto === null ? '—' : hoursSinceAuto + 'h fa'}</div>
          <div class="h-sub">${lastAuto ? lastAuto.toLocaleString('it-IT') : 'nessun backup automatico'}</div>
        </div>
        <div class="health-card">
          <div class="h-label">Backup manuali</div>
          <div class="h-value">${data.backup_manual_tot}</div>
          <div class="h-sub">${data.backup_manual_last ? 'Ultimo: ' + new Date(data.backup_manual_last).toLocaleDateString('it-IT') : 'mai'}</div>
        </div>
        <div class="health-card">
          <div class="h-label">Audit ultime 24h</div>
          <div class="h-value">${data.audit_24h}</div>
        </div>
        <div class="health-card ${data.contratti_scaduti > 0 ? 'warn' : 'ok'}">
          <div class="h-label">Contratti scaduti</div>
          <div class="h-value">${data.contratti_scaduti}</div>
        </div>
        <div class="health-card ${dormant.length > 0 ? 'warn' : 'ok'}">
          <div class="h-label">Utenti dormant</div>
          <div class="h-value">${dormant.length}</div>
          <div class="h-sub">nessun login da 60+ gg</div>
        </div>
      </div>
      ${
        dormant.length
          ? `
        <details>
          <summary class="muted" style="cursor:pointer;font-size:12px;margin-top:6px;">▸ Dettaglio utenti dormant</summary>
          <ul style="margin-top:6px;font-size:12px;padding-left:18px;">
            ${dormant
              .slice(0, 20)
              .map(
                (u) =>
                  `<li>${escapeHtml(u.name)} (${escapeHtml(u.email)}) — ${u.last_seen ? 'ultimo login ' + fmtDateTime(u.last_seen) : 'mai loggato'}</li>`
              )
              .join('')}
          </ul>
        </details>`
          : ''
      }
    `;
  } catch (e) {
    console.error('Health error', e);
    const msg =
      e.code === '42P01' || (e.message || '').toLowerCase().includes('does not exist')
        ? 'La vista health_metrics non è installata. Esegui <code>seed/improvements-schema.sql</code>.'
        : 'Errore caricamento health: ' + (e.message || e);
    root.innerHTML = `<p class="muted">${msg}</p>`;
  }
}

globalThis.renderHealth = renderHealth;
export {};
